export default __webpack_public_path__ + "static/NunitoSans-Variable-0021e92cb2b12c3534a760c3f64cb0b4.ttf";